import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../abstract-component';
import { EncounterAttendenceService } from 'src/app/modules/provider-management/services/encounter-attendence.service';
import { takeUntil } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import {
  EncounterStudentDetail,
  IEncounterParticipantDetail,
} from '../../interfaces/encounter-participant-detail';
import { EncounterResponse } from '../../interfaces/encounter-response';
import { SessionType } from '../../enums/session-type';

@Component({
  selector: 'app-encounter-participants',
  templateUrl: './encounter-participants.component.html',
  styleUrls: ['./encounter-participants.component.scss'],
  standalone: false,
})
export class EncounterParticipantsComponent
  extends AbstractComponent
  implements OnInit
{
  public isScheduledTab: boolean = true;
  scheduledParticipantDetails: EncounterStudentDetail[];
  actualParticipantDetails: EncounterStudentDetail[];
  encounterDetail: EncounterResponse;
  constructor(
    private enccounterService: EncounterAttendenceService,
    private laodingService: LoadingService
  ) {
    super();
  }
  ngOnInit(): void {
    this.laodingService.show();
    this.getParticipantDetails();
  }

  get canShowActualTab(): boolean {
    return this.encounterDetail?.status !== 'Not Started'
      && !!this.encounterDetail?.actualParticipantCount
      && !!this.actualParticipantDetails?.length;
  }

  selectTab(tab: string): void {
    if (tab === 'actual' && !this.canShowActualTab) {
      return;
    }
    this.isScheduledTab = tab === 'scheduled';
  }

  getParticipantDetails(): void {
    const encounterData = JSON.parse(this.encounterDetail?.formJson);
    const sessionType = this.encounterDetail?.sessionType;
    const isMeetingAttendance = sessionType === SessionType.IEPMeetingAttendance;
    const scheduledStudentSks = (isMeetingAttendance && this.encounterDetail?.encounterSk) ? [encounterData?.scheduleMeetingData?.students?.studentSK] : isMeetingAttendance ? [encounterData?.students?.studentSK] : this.encounterDetail?.studentSks;
    const actualStudentSks = (isMeetingAttendance && this.encounterDetail?.encounterSk) ? [encounterData?.actualMeetingData?.students?.studentSK] : this.encounterDetail?.actualStudentSks;
    const payload: {
      scheduleStudentSks: string[];
      actualStudentSks: string[];
    } = {
      scheduleStudentSks: scheduledStudentSks,
      actualStudentSks: actualStudentSks,
    };
    this.enccounterService
      .getParticipantDetails(payload)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: IEncounterParticipantDetail) => {
        this.scheduledParticipantDetails = data?.scheduleStudents;
        this.actualParticipantDetails = data?.actualStudents;
        this.laodingService.hide();
      });
  }

  get participants(): EncounterStudentDetail[] {
    return this.isScheduledTab ||
      (!this.actualParticipantDetails?.length &&
        !!this.scheduledParticipantDetails?.length)
      ? this.scheduledParticipantDetails ?? []
      : this.actualParticipantDetails ?? [];
  }

  trackByStudentId(item: EncounterStudentDetail): string {
    return item?.studentId;
  }

  override afterOnDestroy(): void {
    // No additional cleanup needed
  }
}
